import { ReactNode } from 'react'

import { Column, Row } from '../common/pure/FlexContainer'
import FlowCardStepIndicator from './FlowCardStepIndicator'
import { FlowCardCancelAction, FlowCardDoneAction, FlowCardNextAction } from './FlowCardAction'

interface FlowCardFrameProps {
    content: ReactNode
    aside: ReactNode
}
const FlowCardFrame = ({ aside, content }: FlowCardFrameProps) => (
    // Reuse Primereact card class names to compose a nested card-like container.
    <Row grow className="p-card p-card-component flow-card">
        <div className="p-card-body flow-card__aside">{aside}</div>
        <Column grow className="flow-card__content">
            {content}
        </Column>
    </Row>
)

interface FlowCardProps {
    aside: ReactNode
    currentStep: ReactNode
    steps?: number
    current?: number
    valid?: boolean
    onCancel?: () => void
    onNext?: () => void
    onDone?: () => void
    leftAction?: ReactNode
    stepIndicator?: ReactNode
    rightAction?: ReactNode
}
export default function FlowCard({
    aside,
    currentStep,
    // Either pass the following props...
    steps = 1,
    current = 0,
    valid = true,
    onCancel,
    onNext,
    onDone,
    // ... or provide custom components.
    leftAction = <FlowCardCancelAction onClick={onCancel} />,
    stepIndicator = <FlowCardStepIndicator current={current} steps={steps} />,
    rightAction = current === steps - 1 ? (
        <FlowCardDoneAction onClick={onDone} disabled={!valid} />
    ) : (
        <FlowCardNextAction onClick={onNext} disabled={!valid} />
    ),
}: FlowCardProps) {
    return (
        <FlowCardFrame
            aside={aside}
            content={
                <Column grow>
                    {currentStep}
                    <Row arrangement="spaced">
                        {leftAction}
                        {stepIndicator}
                        {rightAction}
                    </Row>
                </Column>
            }
        />
    )
}
